import { IAction } from "store/store.interface";
import {
  SET_PAYMENT_METHODS,
} from "store/store.types";

export const PAYMENT_METHODS_INITIAL_STATE: IPayments = {
  paymentMethods: [],
};

export interface IPaymentMethods {
  label: string;
  value: string;
}
export interface IPayments {
  paymentMethods?: IPaymentMethods[];
}

const paymentMethodsReducer = (
  state: IPayments = PAYMENT_METHODS_INITIAL_STATE,
  action: IAction
) => {
  switch (action.type) {
    case SET_PAYMENT_METHODS: {
      return { ...state, paymentMethods: action.payload };
    }
    default:
      return state;
  }
};

export default paymentMethodsReducer;
